var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 32.8399V32.8387C41 32.8387 41 32.8386 41 32.8385C40.5411 32.7923 40.1598 32.7488 39.8614 32.7058C37.0111 32.2989 34.2379 31.4669 31.6344 30.2374L28.5915 34.4936L28.1234 35.1484L27.3837 34.8309C20.9991 32.0909 15.9111 27.0029 13.1711 20.6184L12.8535 19.8785L13.5086 19.4104L17.7653 16.3688C16.5355 13.767 15.7025 10.9954 15.2942 8.14644L41 32.8399ZM41 32.8399V39.912V39.9126M41 32.8399V39.9126M41 39.9126C41.0002 40.1656 40.9043 40.4093 40.7316 40.5946L40.7315 40.5948M41 39.9126L40.7315 40.5948M40.7315 40.5948C40.5595 40.7794 40.3237 40.8922 40.0715 40.9104C39.2065 40.9698 38.5186 41 38 41C20.8783 41 7 27.1217 7 10C7 9.48036 7.0284 8.79195 7.08949 7.93076L7.08955 7.93M40.7315 40.5948L7.08955 7.93M7.08955 7.93C7.10727 7.67745 7.22013 7.44101 7.40535 7.26841C7.59057 7.09581 7.83437 6.99989 8.08755 7H8.088M7.08955 7.93L8.088 7M8.088 7L15.16 7L15.161 7M8.088 7L15.161 7M15.161 7C15.161 7 15.161 7 15.161 7.00001C15.2075 7.46449 15.2511 7.8468 15.2941 8.14584L15.161 7ZM42 32.8399V39.912V32.8399Z",
    stroke: "#000064",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvg);
export default __webpack_public_path__ + "static/media/phoneSvg.9e0804862c17d134745cf57d04c91049.svg";
export { ForwardRef as ReactComponent };